export type TypeGuard<T> = (value: unknown) => value is T;

const { hasOwnProperty } = Object.prototype;

export function hasOwn(obj: unknown, key: PropertyKey): obj is Record<PropertyKey, unknown> {
  return typeof obj === "object" && obj !== null && hasOwnProperty.call(obj, key);
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === "boolean";
}

export function isNull(value: unknown): value is null {
  return value === null;
}

export function isNullable<T>(guard: TypeGuard<T>): TypeGuard<T | null> {
  return (value: unknown): value is T | null => value === null || guard(value);
}

export function isArrayOf<T>(guard: TypeGuard<T>): TypeGuard<T[]> {
  return (value: unknown): value is T[] => Array.isArray(value) && value.every(guard);
}

export function isArrayOfOrNull<T>(guard: TypeGuard<T>): TypeGuard<T[] | null> {
  return (value: unknown): value is T[] | null => value === null || isArrayOf(guard)(value);
}
